import { MESSAGE_TYPE } from 'shared/constants/messages';
import { applyPageFilters, applyRoleFilter, sortComparator } from './helpers';
import filterQueryGenerator from 'dashboard/helper/filterQueryGenerator';
import { matchesFilters } from './helpers/filterHelpers';
import {
  getUserPermissions,
  getUserRole,
} from '../../../helper/permissionsHelper';
import camelcaseKeys from 'camelcase-keys';

export const getSelectedChatConversation = ({
  allConversations,
  selectedChatId,
}) =>
  allConversations.filter(conversation => conversation.id === selectedChatId);

/**
 * Deprecated: O pessoal do Chatwoot já fez uma nova lógica dentro do helper sortComparator,
 * então vou levar as modificações feitas nessa função até agora (sort_on_agent_last_seen_at) para lá
 */
// const sortComparator = {
//   latest: (a, b) => b.last_activity_at - a.last_activity_at,
//   sort_on_created_at: (a, b) => a.created_at - b.created_at,
//   sort_on_priority: (a, b) => {
//     return (
//       CONVERSATION_PRIORITY_ORDER[a.priority] -
//       CONVERSATION_PRIORITY_ORDER[b.priority]
//     );
//   },
//   sort_on_waiting_since: (a, b) => {
//     if (!a.waiting_since && !b.waiting_since) {
//       return a.created_at - b.created_at;
//     }

//     if (!a.waiting_since) {
//       return 1;
//     }

//     if (!b.waiting_since) {
//       return -1;
//     }

//     return a.waiting_since - b.waiting_since;
//   },
//   sort_on_agent_last_seen_at: (a, b) => {
//     if (a.unread_count > 0 && b.unread_count === 0) {
//       return -1;
//     }
//     if (a.unread_count === 0 && b.unread_count > 0) {
//       return 1;
//     }
//     return b.last_activity_at - a.last_activity_at;
//   },
// };

// getters
const getters = {
  getAllConversations: ({ allConversations, chatSortFilter: sortKey }) => {
    return allConversations.sort((a, b) => sortComparator(a, b, sortKey));
  },
  getFilteredConversations: (
    { allConversations, chatSortFilter, appliedFilters, appliedFiltersSortBy },
    _,
    __,
    rootGetters
  ) => {
    const currentUser = rootGetters.getCurrentUser;
    const currentUserId = rootGetters.getCurrentUser.id;
    const currentAccountId = rootGetters.getCurrentAccountId;

    const permissions = getUserPermissions(currentUser, currentAccountId);
    const userRole = getUserRole(currentUser, currentAccountId);

    return allConversations
      .filter(conversation => {
        const matchesFilterResult = matchesFilters(
          conversation,
          appliedFilters
        );
        const allowedForRole = applyRoleFilter(
          conversation,
          userRole,
          permissions,
          currentUserId
        );

        return matchesFilterResult && allowedForRole;
      })
      .sort((a, b) =>
        sortComparator(a, b, appliedFiltersSortBy || chatSortFilter)
      );
  },
  getSelectedChat: ({ selectedChatId, allConversations }) => {
    const selectedChat = allConversations.find(
      conversation => conversation.id === selectedChatId
    );
    return selectedChat || {};
  },
  getSelectedChatAttachments: ({ selectedChatId, attachments }) => {
    return attachments[selectedChatId] || [];
  },
  getSelectedChatAttachmentsLoaded: ({ selectedChatId, attachments }) =>
    selectedChatId !== null && attachments[selectedChatId] !== undefined,
  getChatListFilters: ({ conversationFilters }) => conversationFilters,
  getLastEmailInSelectedChat: (stage, _getters) => {
    const selectedChat = _getters.getSelectedChat;
    const { messages = [] } = selectedChat;
    const lastEmail = [...messages].reverse().find(message => {
      const { message_type: messageType } = message;
      if (message.private) return false;

      return [MESSAGE_TYPE.OUTGOING, MESSAGE_TYPE.INCOMING].includes(
        messageType
      );
    });

    return lastEmail;
  },
  getMineChats: (_state, _, __, rootGetters) => activeFilters => {
    const currentUserID = rootGetters.getCurrentUser?.id;

    return _state.allConversations.filter(conversation => {
      const { assignee } = conversation.meta;
      const isAssignedToMe = assignee && assignee.id === currentUserID;
      const shouldFilter = applyPageFilters(conversation, activeFilters);
      const isChatMine = isAssignedToMe && shouldFilter;

      return isChatMine;
    });
  },
  getAppliedConversationFiltersV2: _state => {
    // TODO: Replace existing one with V2 after migrating the filters to use camelcase
    return _state.appliedFilters.map(camelcaseKeys);
  },
  getAppliedConversationFilters: _state => {
    return _state.appliedFilters;
  },
  getAppliedContactFilter: ({ appliedFilters }) => {
    const [filter, ...rest] = appliedFilters;
    if (rest.length || filter?.attribute_key !== 'contact_id') return null;

    return filter.values?.[0] ?? null;
  },
  getAppliedConversationFiltersQuery: _state => {
    const hasAppliedFilters = _state.appliedFilters.length !== 0;
    return hasAppliedFilters ? filterQueryGenerator(_state.appliedFilters) : [];
  },
  getParticipatingChats: (_state, _, __, rootGetters) => activeFilters => {
    const currentUserId = rootGetters.getCurrentUser?.id;
    const getWatchers = rootGetters['conversationWatchers/getByConversationId'];
    return _state.allConversations.filter(conversation => {
      const watchers = getWatchers(conversation.id);
      // Watchers are only loaded for the conversation open in the detail
      // panel. If loaded and current user is not in them, filter it out.
      if (watchers && !watchers.some(w => w.id === currentUserId)) {
        return false;
      }
      return applyPageFilters(conversation, activeFilters);
    });
  },
  getUnAssignedChats:
    (_state, _, __, rootGetters) => (activeFilters, teamsList) => {
      // Filtra as conversas caso seja um agente que selecionou o filtro 'NÃO ATRIBUIDO'
      const currentUser = rootGetters.getCurrentUser;
      if (currentUser?.role === 'agent') {
        return _state.allConversations.filter(conversation => {
          const { team } = conversation.meta;
          const isUnAssigned = !conversation.meta.assignee;

          const assignedToAgentTeam =
            team &&
            teamsList &&
            teamsList.find(e => e.id === team.id)?.is_member;
          const shouldFilter = applyPageFilters(conversation, activeFilters);

          return isUnAssigned && shouldFilter && (!team || assignedToAgentTeam);
        });
      }

      return _state.allConversations.filter(conversation => {
        const isUnAssigned = !conversation.meta.assignee;
        const shouldFilter = applyPageFilters(conversation, activeFilters);
        return isUnAssigned && shouldFilter;
      });
    },
  getAllStatusChats:
    (_state, _, __, rootGetters) => (activeFilters, teamsList) => {
      const currentUser = rootGetters.getCurrentUser;

      // Filtra as conversas caso seja um agente que selecionou o filtro 'TODOS'
      if (currentUser?.role === 'agent') {
        return _state.allConversations.filter(conversation => {
          const { assignee, team } = conversation.meta;
          const isAssignedToMe = assignee && assignee.id === currentUser?.id;

          const isUnAssigned = !conversation.meta.assignee;
          const assignedToAgentTeam =
            team &&
            teamsList &&
            teamsList.find(e => e.id === team.id)?.is_member;
          const assignedToTeamAndNoAgent = assignedToAgentTeam && isUnAssigned;
          const noTeamAndNoAgent = isUnAssigned && !team;

          const shouldFilter = applyPageFilters(conversation, activeFilters);

          return (
            shouldFilter &&
            (isAssignedToMe || assignedToTeamAndNoAgent || noTeamAndNoAgent)
          );
        });
      }
      return _state.allConversations.filter(conversation => {
        const shouldFilter = applyPageFilters(conversation, activeFilters);
        return shouldFilter;
      });
    },
  getChatListLoadingStatus: ({ listLoadingStatus }) => listLoadingStatus,
  getAllMessagesLoaded(_state) {
    const [chat] = getSelectedChatConversation(_state);
    return !chat || chat.allMessagesLoaded === undefined
      ? false
      : chat.allMessagesLoaded;
  },
  getUnreadCount(_state) {
    const [chat] = getSelectedChatConversation(_state);
    if (!chat) return [];
    return chat.messages.filter(
      chatMessage =>
        chatMessage.created_at * 1000 > chat.agent_last_seen_at * 1000 &&
        chatMessage.message_type === 0 &&
        chatMessage.private !== true
    ).length;
  },
  getChatStatusFilter: ({ chatStatusFilter }) => chatStatusFilter,
  getChatSortFilter: ({ chatSortFilter }) => chatSortFilter,
  getSelectedInbox: ({ currentInbox }) => currentInbox,
  getConversationById: _state => conversationId => {
    return _state.allConversations.find(
      value => value.id === Number(conversationId)
    );
  },
  getConversationParticipants: _state => {
    return _state.conversationParticipants;
  },
  getConversationLastSeen: _state => {
    return _state.conversationLastSeen;
  },

  getContextMenuChatId: _state => {
    return _state.contextMenuChatId;
  },

  getCopilotAssistant: _state => {
    return _state.copilotAssistant;
  },
};

export default getters;
